import { render } from "./hub.vue?vue&type=template&id=6107643f&ts=true"
import script from "./hub.vue?vue&type=script&lang=ts"
export * from "./hub.vue?vue&type=script&lang=ts"

import "./hub.vue?vue&type=style&index=0&id=6107643f&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__